(() => {
  const root = document.querySelector('[data-sauna-ofen-guide]');
  if (!root) return;

  const cards = Array.from(root.querySelectorAll('[data-sauna-ofen-card]'));
  const hint = root.querySelector('[data-sauna-ofen-guide-hint]');

  function getVariantIdFromEvent(e) {
    const v = e?.detail?.variant;
    if (v && (v.id || v.variantId)) return String(v.id || v.variantId);
    return null;
  }

  function getVariantIdFallback() {
    const input =
      document.querySelector('form[action^="/cart/add"] [name="id"]') ||
      document.querySelector('[name="id"][value]');
    return input?.value ? String(input.value) : null;
  }

  function showCard(variantId) {
    if (!variantId) return;

    let anyShown = false;
    for (const c of cards) {
      const match = c.getAttribute('data-variant-id') === String(variantId);
      c.classList.toggle('is-hidden', !match);
      if (match) anyShown = true;
    }

    if (hint) hint.classList.toggle('is-hidden', anyShown);
  }

  // Focal/Maestrooo Events (wir hören mehrere Namen + Fallback)
  document.addEventListener('variant:changed', (e) => {
    showCard(getVariantIdFromEvent(e) || getVariantIdFallback());
  });

  document.addEventListener('variant:change', (e) => {
    showCard(getVariantIdFromEvent(e) || getVariantIdFallback());
  });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.matches('form[action^="/cart/add"] [name="id"]') || t.matches('[name="id"]')) {
      showCard(String(t.value));
    }
  });

  // Initial
  showCard(new URL(window.location.href).searchParams.get('variant') || getVariantIdFallback());
})();
